// extracted by mini-css-extract-plugin
export default {"wrapper":"_4569c5b"};